import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-disabled',
    imports: [],
    templateUrl: './icon-disabled.component.html',
})
export class IconDisabled {
    @Input() color: string = '#E41B2E';
    @Input() size: string = '24px';
}